import { NativeEventSource, EventSourcePolyfill } from 'event-source-polyfill';
import env from 'env';

export const init_session_observer = (uid, observer, response_observable) => {
  let observe;
  if (observer === 'sse') {
    try {
      observe = new EventSource(`${env.apiUri}${env.apiPrefix}sse/${uid}/`);

    } catch (error) {
      try {
        const EventSource = NativeEventSource || EventSourcePolyfill;
        observe = new EventSource(`${env.apiUri}${env.apiPrefix}sse/${uid}/`);

      } catch (error) {
        observe = new WebSocket(`${env.wsUri}${env.apiPrefix}ws/${uid}/`);
      }
    }

  } else {
    observe = new WebSocket(`${env.wsUri}${env.apiPrefix}ws/${uid}/`);
  }
  const timeout = setTimeout(() => {
    observe.close();
    response_observable.data = {code: 500};
  }, 120000);

  observe.onmessage = (ev) => {
    clearTimeout(timeout);
    observe.close();
    response_observable.data = JSON.parse(ev.data);
  };
  observe.onerror = () => response_observable.data = {code: 500};
}
